(function () {
  if (customElements.get('ce-disclosure') !== undefined) {
    return;
  }

  class Disclosure extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        details: '[data-disclosure-details]',
        buttonToggle: '[data-disclosure-button-toggle]',
        panel: '[data-disclosure-panel]',
      };

      this.elements = null;

      this.handleClickButtonToggle = this.handleClickButtonToggle.bind(this);
    }

    get isOpen() {
      return this.getAttribute('is-open') === 'true';
    }

    set isOpen(value) {
      this.setAttribute('is-open', value);
    }

    static get observedAttributes() {
      return ['is-open'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'is-open':
          if (newValue !== null) {
            if (newValue === 'true') {
              this.elements.details.setAttribute('open', '');
              this.elements.buttonToggle.setAttribute('aria-expanded', 'true');
              this.elements.buttonToggle.setAttribute('aria-pressed', 'true');
              this.elements.panel.style.visibility = 'visible';
            } else {
              this.elements.details.removeAttribute('open');
              this.elements.buttonToggle.setAttribute('aria-expanded', 'false');
              this.elements.buttonToggle.setAttribute('aria-pressed', 'false');
              this.elements.panel.style.visibility = 'hidden';
            }
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        details: this.querySelector(this.selectors.details),
        buttonToggle: this.querySelector(this.selectors.buttonToggle),
        panel: this.querySelector(this.selectors.panel),
      };

      this.elements.buttonToggle.addEventListener('click', this.handleClickButtonToggle);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.buttonToggle.removeEventListener('click', this.handleClickButtonToggle);
    }

    handleClickButtonToggle(event) {
      event.preventDefault();
      this.isOpen = !this.isOpen;
    }
  }

  customElements.define('ce-disclosure', Disclosure);
})();
